import { render, staticRenderFns } from "./IndagineEpidemiologicaMorbilloRosoliaViewComponent.vue?vue&type=template&id=5b74a00a"
import script from "./IndagineEpidemiologicaMorbilloRosoliaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMorbilloRosoliaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports